module.exports = __webpack_public_path__ + "static/media/photo93.4928ed56.jpg";